export interface Variety {
    id?: string;
    cropTypeId: string;
    name: string;
    seedType: SeedType;
    cropCode: string;
    color?: string;
}

export enum SeedType {
    Pelleted = 'PELLETED',
    Raw = 'RAW',
}
